import React, { HTMLAttributes } from 'react'

import theme from '../../global/theme'

export const FieldContainer: React.FC<
  React.PropsWithChildren<
    React.HTMLAttributes<HTMLDivElement> & { isError?: boolean }
  >
> = ({ children, isError = false, style, ...props }) => (
  <div
    style={{
      ...style,
      marginBottom: '20px',
      ...(isError && {
        padding: '10px',
        border: `1px solid ${theme.colors.secondary}`,
        backgroundColor: theme.colors.contrastSecondary,
        borderRadius: '8px',
      }),
    }}
    {...props}
  >
    {children}
  </div>
)

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean
}

export const Input: React.FC<InputProps> = ({ error = false, ...props }) => (
  <input
    style={{
      width: '100%',
      padding: '12px',
      border: `1px solid ${error ? 'red' : '#ddd'}`,
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
      transition: 'border-color 0.3s ease',
    }}
    {...props}
  />
)

type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  error?: boolean
  children?: React.ReactNode
}

export const Select: React.FC<SelectProps> = ({
  error,
  children,
  ...props
}) => (
  <select
    style={{
      width: '100%',
      padding: '12px',
      border: `1px solid ${error ? 'red' : '#ddd'}`,
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
      backgroundColor: 'white',
    }}
    {...props}
  >
    {children}
  </select>
)

export const RadioGroup: React.FC<
  React.PropsWithChildren<HTMLAttributes<HTMLDivElement>>
> = ({ children, ...props }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      marginTop: '10px',
    }}
    {...props}
  >
    {children}
  </div>
)

export const RadioOption: React.FC<
  React.PropsWithChildren<HTMLAttributes<HTMLLabelElement>>
> = ({ children, ...props }) => (
  <label
    style={{
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: theme.colors.textGrey,
    }}
  >
    {children}
  </label>
)

export const CheckboxGroup: React.FC<
  React.PropsWithChildren<HTMLAttributes<HTMLDivElement>>
> = ({ children, ...props }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      marginTop: '10px',
    }}
    {...props}
  >
    {children}
  </div>
)

export const CheckboxOption: React.FC<
  React.PropsWithChildren<HTMLAttributes<HTMLLabelElement>>
> = ({ children, ...props }) => (
  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
    {children}
  </label>
)

export const ErrorText: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ children, ...props }) => (
  <p
    style={{
      color: theme.colors.secondary,
      fontSize: '12px',
      marginTop: '4px',
    }}
    {...props}
  >
    {children}
  </p>
)
